<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">LOGS DO RADIUS</li>
                </ol>

                <div class="col-md-12">

                    <table id="mytable" class="table table-bordred table-striped">

                        <thead>
                            <tr>
                                <th>TEXTO</th>
                                <th class="text-center" style="width: 130px">DATA</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r in comandos" >
                                <td>{{ r.texto }}</td>
                                <td class="text-center" >{{ r.data | date('DD/MM/YYYY HH:mm:ss') }}</td>
                            </tr>
                        </tbody>

                    </table>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { date } from "../../filters";
export default {
    filters: {
        date
    },
    data() {
        return {
            comandos: []
        };
    },
    beforeMount() {
        // eslint-disable-next-line no-undef
        this.socket = io.connect(
            this.$http.options.root,
            { reconnect: true, transports: ["websocket", "polling"] }
        );
        this.socket.on("auth", data => {
            this.comandos.push(data);
        });
    },
    beforeDestroy() {
        this.socket.close();
    }
};
</script>
